import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import AuthAPI from "../AuthAPI";

export const _PaySlips = {
    pagination: (id_dipendente, year, page = 1) => {
        const staffIds = Array.isArray(id_dipendente) ? id_dipendente : [id_dipendente];
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/pay-slips/pagination"),
            {
                'id_dipendente[]': staffIds,
                year: year,
                page: page,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    sign: (pay_slip_id, signature_svg) => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/pay-slips/sign"),
            {
                pay_slip_id: pay_slip_id,
                signature_svg: signature_svg,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    }
};
